import React, { useState } from 'react';
import axios from 'axios';
import { Button, Card, CardContent, TextField, Typography } from '@mui/material';
import { useAuth } from '../AuthContext'; // Assuming useAuth for token
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill's CSS

// Import Quill's core and additional modules
import Quill from "quill";
import "quill/dist/quill.snow.css"; // Import the theme CSS

// Define custom toolbar options
const toolbarOptions = [
  [{ font: [] }],
  [{ size: [] }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
  ["image"],
  // ["blockquote", "code-block"],
];

// Register custom formats
const Size = Quill.import("attributors/style/size");
Quill.register(Size, true);

const Font = Quill.import("formats/font");
Font.whitelist = [
  "arial",
  "comic-sans",
  "courier",
  "georgia",
  "helvetica",
  "impact",
  "times-new-roman",
  "trebuchet-ms",
  "verdana",
];
Quill.register(Font, true);

const NewProject = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [statusMessage, setStatusMessage] = useState("");
  const { token } = useAuth();

  const handleFileChange = (e) => {
    setSelectedFiles([...selectedFiles, ...e.target.files]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage(""); // Clear any previous messages
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("description", description); // Rich-text description
      selectedFiles.forEach((file) => {
        formData.append("photos", file);
      });

      await axios.post(
        "https://sirius.runasp.net/api/Project",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setName("");
      setDescription("");
      setSelectedFiles([]);
      setStatusMessage("Project created successfully!");
    } catch (error) {
      console.error(
        "There was an error creating the project!",
        error.response?.data || error.message
      );
      setStatusMessage("There was an error creating the project. Please try again.");
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Card style={{ width: "500px", marginBottom: "1rem" }}>
        <CardContent>
          <Typography variant="h6" style={{ marginBottom: "2rem" }}>
            Create New Project
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Project Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ marginBottom: "1rem" }}
            />
            <ReactQuill
              value={description}
              onChange={setDescription}
              theme="snow"
              modules={{ toolbar: toolbarOptions }}
              placeholder="Write your project description here..."
              style={{ marginBottom: "1rem" }}
            />
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              style={{ marginBottom: "1rem" }}
            />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                marginBottom: "1rem",
              }}
            >
              {selectedFiles.map((file, index) => (
                <img
                  key={index}
                  src={URL.createObjectURL(file)}
                  alt={`preview ${index}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    marginRight: "10px",
                  }}
                  onLoad={() => URL.revokeObjectURL(file)} // Revoke URL after image is loaded
                />
              ))}
            </div>
            <Button type="submit" variant="contained" color="primary" style={{ marginBottom: "1rem" }}>
              Create
            </Button>
          </form>
          {statusMessage && (
            <Typography
              variant="body1"
              style={{
                color: statusMessage.includes("successfully") ? "green" : "red",
              }}
            >
              {statusMessage}
            </Typography>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default NewProject;
